import { put, call, takeLatest, takeEvery } from "redux-saga/effects";

import { CONCILIATED } from "../actions";
import generateAction from "../../utils/action-helpers";

import redirectToLogin from "../../utils/redirect-to-login";

import { fetchConciliated } from "../../api/conciliated";
import { getItem } from "../../api/item";

function* fetchConciliatedSaga(action) {
  try {
    const response = yield call(fetchConciliated, action.payload);
    yield put(generateAction(CONCILIATED.FETCH_SUCCESS, response.data));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(CONCILIATED.FETCH_ERROR));
  }
}

const getItemWithDocument = (
  position,
  year,
  period,
  society,
  customer,
  documentParam,
  expiration
) =>
  new Promise((resolve, reject) => {
    getItem(position, year, period, society, customer, documentParam, expiration)
      .then(result => resolve({ ...result, data: { ...result.data, document: documentParam } }))
      .catch(error => reject(error));
  });

const getItems = items =>
  new Promise((resolve, reject) => {
    const promises = [];
    items.forEach(item => {
      const {
        position,
        year,
        period,
        society,
        customer,
        document: documentParam,
        expiration
      } = item;
      promises.push(
        getItemWithDocument(position, year, period, society, customer, documentParam, expiration)
      );
    });
    Promise.all(promises)
      .then(result => resolve(result))
      .catch(error => reject(error));
  });

function* getItemsSaga(action) {
  const { kukey, record, items } = action.payload;
  try {
    const results = yield call(getItems, items);
    yield put(
      generateAction(CONCILIATED.GET_ITEMS_SUCCESS, {
        kukey,
        record,
        loadedItems: results.map(result =>
          result && result.data && result.data[0] ? result.data[0] : {}
        )
      })
    );
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(CONCILIATED.GET_ITEMS_ERROR, { kukey, record }));
  }
}

export default function* conciliatedSaga() {
  yield takeLatest(CONCILIATED.FETCH, fetchConciliatedSaga);
  yield takeEvery(CONCILIATED.GET_ITEMS, getItemsSaga);
}
